<template>
    <div :class="[alignmentClass, themeSetting('center_logo') == 1 && 'partner-centered']">
        <div :class="{ 'cobranding-wrapper': true, 'no-text': !coBranding.text }" v-if="coBranding && coBranding.logo">
            <a v-if="!isStaticPage" :href="partnerThemeSettings" class="d-flex flex-column">
                <span v-if="coBranding && coBranding.text" class="cobranding-text">
                    {{ coBranding.text }}
                </span>
                <img class="partner__logo cobranding-logo" width="185" :src="coBranding.logo" alt="Monevo" />
            </a>
            <div v-else class="d-flex flex-column">
                <span v-if="coBranding && coBranding.text" class="cobranding-text">
                    {{ coBranding.text }}
                </span>
                <img class="partner__logo cobranding-logo" width="185" :src="coBranding.logo" alt="Monevo" />
            </div>
        </div>

        <div class="powered-by-logo" v-else>
            <a v-if="!isStaticPage && isLogoClickEnabled" :href="monevoThemeSettings">
                <img
                    class="partner__logo"
                    :src="asset(`/img/logos/${themeSetting('monevo_logo')}`)"
                    alt="Monevo"
                    width="110"
                />
            </a>
            <div v-else>
                <img
                    class="partner__logo"
                    :src="asset(`/img/logos/${themeSetting('monevo_logo')}`)"
                    alt="Monevo"
                    width="110"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import isEmpty from 'lodash/isEmpty'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    props: {
        alignment: {
            default: '',
        },
        isStaticPage: {
            default: false,
        },
    },
    computed: {
        pageData: function () {
            return this.store.state.global.page || null
        },
        isLogoClickEnabled: function () {
            return parseInt(this.themeSetting('disable_logo_click')) !== 1
        },
        coBranding: function () {
            if (this.pageData && this.pageData.cobranding_logo) {
                return {
                    logo: this.pageData.cobranding_logo,
                    text: this.pageData.cobranding_text,
                }
            }

            return null
        },
        alignmentClass: function () {
            if (this.alignment) {
                return `partner-${this.alignment}`
            }

            return 'partner'
        },
        partnerThemeSettings: function () {
            return !isEmpty(this.themeSetting('partner_callback_url'))
                ? this.themeSetting('partner_callback_url')
                : this.url('/')
        },
        monevoThemeSettings: function () {
            return !isEmpty(this.themeSetting('monevo_callback_url'))
                ? this.themeSetting('monevo_callback_url')
                : this.url('/')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';

.partner {
    @media screen and (min-width: $bp-medium) {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
    }
}

.partner-right {
    position: relative;
}

.powered-by-logo {
    display: inline-block;

    img {
        max-height: 45px;
    }

    @media screen and (min-width: $bp-large) {
        img {
            max-height: 65px;
        }
    }
}

.partner-right {
    padding-left: 15px;

    .powered-by-logo {
        padding-left: 0px;
    }

    img {
        @media screen and (min-width: $bp-large) {
            margin-left: -30px;
        }
    }

    a {
        filter: none !important;
    }
}

.cobranding-wrapper {
    display: inline-block;
    padding-left: 10px;

    @media screen and (min-width: $bp-large) {
        &.no-text {
            margin-top: 0;

            .cobranding-logo {
                max-height: 55px;
            }
        }
    }

    .cobranding-logo {
        max-width: 185px;

        @media screen and (min-width: $bp-large) {
            max-height: 55px;
        }
    }

    .cobranding-text {
        font-size: 12px;
        font-weight: 400;
        min-width: 100%;
        text-align: right;
        white-space: nowrap;
    }
}
</style>
